import { Accordion, AccordionTab } from "primereact/accordion"
import { useState } from "react";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { TablaEditableComponent } from "../../components/TablaEditableComponent";
import { ProgressSpinner } from "primereact/progressspinner";

export const ParametroEmpresa = ({ permss, generic, toast, funcionalidades }) => {

    const [activeIndex, setActiveIndex] = useState(null);
    const monitoreoService = new MonitoreoService();
    const [info, setInfo] = useState(null);

    const readOnlyFieldsMap = {
        0: ['nombre'],
        1: ['nombre'],
        2: ['nombre'],
        3: ['nombre'], // ['nombre','color_bg']
        4: ['nombre'],
        5: ['nombre'],
        6: ['nombre'],
    };

    const handleTabChange = (e) => {
        if (e.index === null) {
            setActiveIndex(null);
            setInfo(null);
            return;
        }

        setInfo(null);
        setActiveIndex(e.index);

        monitoreoService.consultar(e.index, 'monitoreo/parametro/empresa').then((res) => {
            setInfo(res.data);
        });
    };

    const handleRowUpdate = (rowData) => {
        const payload = { ...rowData, opcion: activeIndex };

        return monitoreoService.editar(payload, 'monitoreo/parametro/editar-configuracion')
            .then((response) => {
                toast.current.show({ severity: 'success', detail: 'Guardado' });
                return response;
            })
            .catch((error) => {
                if (error.response?.status === 422) {
                    const errores = error.response.data.errors;
                    const mensajes = Object.values(errores).flat().join('\n');
                    toast.current.show({ severity: 'warn', detail: mensajes });
                } else {
                    toast.current.show({ severity: 'error', detail: 'Error al guardar' });
                }
            });
    };

    // Filtramos los datos presentados en la tabla
    const getDatosTabla = () => {
        if (!info) return [];
        if ([0, 1].includes(activeIndex)) return info.parametros || [];
        if ([2, 3, 4, 5, 6].includes(activeIndex)) return info.colores || [];
        return [];
    };

    const progresoCarga = () => {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '2rem' }}>
                <ProgressSpinner style={{ width: '50px', height: '57.5px' }} strokeWidth="5" fill="var(--surface-ground)" animationDuration=".5s" />
            </div>
        )
    }

    const renderTabla = () => {
        return (
            <TablaEditableComponent data={getDatosTabla()} onRowUpdate={handleRowUpdate} readOnlyFields={readOnlyFieldsMap[activeIndex]}
                coloresBase={info.coloresBase} activeIndex={activeIndex} />
        );
    };

    const siOpcion = (key) => {
        return permss?.actualizar && (funcionalidades.includes('PRELAFIT') || funcionalidades.includes(key));
    };

    const tabsConfig = [
        {
            header: "PARÁMETROS DE MONITOREO",
            funcionalidad: "monitoreo-transaccion-inversion-minima"
        },
        {
            header: "INSTRUMENTO DE PAGO",
            funcionalidad: "monitoreo-transaccion-instrumentos-pago"
        },
        {
            header: "SIMBOLOGIA: NIVEL DE RIESGO DE TRANSACCIÓN Y ALERTA POR MEDIO DE PAGOS",
            funcionalidad: "monitoreo-transaccion-colores-riesgo-pago"
        },
        {
            header: "SIMBOLOGIA: ALERTAS",
            funcionalidad: "monitoreo-transaccion-colores-alerta"
        },
        {
            header: "SIMBOLOGIA: SUPERA UMBRAL",
            funcionalidad: "monitoreo-transaccion-colores-supera"
        },
        {
            header: "SIMBOLOGIA: NIVELES DE RIESGO DE NIVEL DE RIESGO DE PERFIL",
            funcionalidad: "monitoreo-perfil-colores-riesgo"
        },
        {
            header: "SIMBOLOGIA: ALERTAS DE NIVEL DE RIESGO DE PERFIL",
            funcionalidad: "monitoreo-perfil-colores-alerta"
        }
    ];

    return (
        <>
            <Accordion activeIndex={activeIndex} onTabChange={handleTabChange}>
                {tabsConfig.map((tab, index) => {
                    const tienePermiso = siOpcion(tab.funcionalidad);
                    return (
                        <AccordionTab key={index} header={tab.header} style={!tienePermiso ? { display: 'none' } : {}}>
                            {tienePermiso ? (info ? renderTabla() : progresoCarga()) : null}
                        </AccordionTab>
                    );
                })}
            </Accordion>
        </>
    )
}
